export default __webpack_public_path__ + "static/m-customer4-d25274a4230a78befd85f0288db6e300.png";